var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 220,
    viewBox: "0 0 93 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 58.5413C85.7111 58.5413 60.3465 83.1471 60.3465 113.5C60.3465 143.853 85.7111 168.459 117 168.459C148.289 168.459 173.654 143.853 173.654 113.5C173.654 83.1471 148.289 58.5413 117 58.5413ZM0 113.5C0 50.8157 52.3827 0 117 0C181.617 0 234 50.8157 234 113.5C234 176.184 181.617 227 117 227C52.3827 227 0 176.184 0 113.5Z",
    fill: "#CDDEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBottom);
export default __webpack_public_path__ + "static/media/box-bottom.daf5c13e0c89c9ca6e86f89b269b40c1.svg";
export { ForwardRef as ReactComponent };